import { render } from "./ReviewStats.vue?vue&type=template&id=318ff761"
import script from "./ReviewStats.vue?vue&type=script&lang=js"
export * from "./ReviewStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__